import React from 'react';

export const paymentInformationTitle = 'Set up direct deposit';

export const EligibilityRegulationNote = () => (
  <>
    <va-alert status="warning" uswds visible>
      <h3 slot="headline">
        We’ll use this bank account for all your VA benefit payments
      </h3>
      <p>
        If we approve your disability benefits claim, we’ll use the bank account
        you provide here for all your VA benefit payments.
      </p>
    </va-alert>
    <p>
      We make payments only through direct deposit, also called electronic funds
      transfer (EFT). Provide your direct deposit information here. We’ll send
      your VA benefit payments to this account.
    </p>
  </>
);

export const CheckGuideDetails = () => (
  <>
    <img
      key="check-image-src"
      src="/img/direct-deposit-check-guide.svg"
      alt="On a personal check, find your bank’s 9-digit routing number listed along the bottom-left edge, and your account number listed beside that."
    />
    <p>
      Your bank’s routing number is listed along the bottom-left edge of a
      personal check. Your account number is listed to the right of that.
      Routing numbers must be 9-digits and account numbers can be up to 17
      digits.
    </p>
  </>
);
